module.exports = "/images/gr.svg?0b97d00c85b82b2200127c7d23e7615a";